import emptySliceApi from '../../shared/store/emptyApiSlice';

export interface StatisticsApiModel {
  totalRegisteredUsers: number;
  totalAdministratorsCount: number;
  totalPendingInvites: number;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccountStatistics: builder.query<StatisticsApiModel, string>({
      query: (accountId) => `/accounts/${accountId}/statistics`,
      providesTags: ['Admin', 'User'],
    }),
  }),
});

export const { useGetAccountStatisticsQuery } = apiSlice;
